import { memo, useEffect } from 'react'
import Button from '../Button'
import './styles.css'

const Modal = memo(function Modal({ isOpen, onClose, title = 'Ajustes', children, onApply, applyLabel, cancelLabel }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const isSmallModal = title === 'Descargar' || title === 'Compartir'

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-container ${isSmallModal ? 'modal-container--small' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="#2A594D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="modal-content">
          {children}
        </div>
        <div className="modal-footer">
          <Button variant="secondary" onClick={onClose}>
            {cancelLabel || 'Cerrar'}
          </Button>
          {onApply && (
            <Button variant="accent" onClick={() => {
              onApply()
            }}>
              {applyLabel || (title === 'Descargar' ? 'Descargar' : title === 'Compartir' ? 'Compartir' : 'Aplicar')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
})

export default Modal
